import { useEffect, useRef, useState } from 'react'

export default function CameraBackground({ experienceType = 'int' }) {
    const videoRef = useRef()
    const [hasCamera, setHasCamera] = useState(true)

    useEffect(() => {
        async function setupCamera() {
            try {
                // Vuelve a pedir permisos, pero no va a mostrar el popup porque el usuario ya los dió. Es para no tener que pasar el stream hasta acá.
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: { 
                        facingMode: 'environment',
                        width: { ideal: 4096 },
                        height: { ideal: 2160 }
                    }
                })
                
                if (videoRef.current) {
                    videoRef.current.srcObject = stream

                    const video = videoRef.current;
                    video.srcObject = stream;
                }
                
                setHasCamera(true)
            } catch {
                setHasCamera(false)
            }
        }

        setupCamera()

        return () => {
            if (videoRef.current?.srcObject) {
                videoRef.current.srcObject.getTracks().forEach(track => track.stop())
            }
        }
    }, [])

    if (!hasCamera) {
        if (experienceType === 'ext') {
            // Experiencia exterior
            return (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: 'url(/images/components/LandingPageExt/ext-no-camera-background.webp)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    zIndex: -1
                }} />
            )
        } else {
            // Experiencia interior
            return (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: '#007AE5',
                    zIndex: -1
                }} />
            )
        }
    }
    return (
        <video
            ref={videoRef}
            autoPlay
            playsInline
            muted
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                background: 'black', // para que las bandas se vean prolijas
                zIndex: -1
            }}
        />
    )
    
}